export const CHOICE_QUESION_TYPE = 'App\\ChoiceQuestion';
export const PICTURE_QUESION_TYPE = 'App\\PictureQuestion';

export const USER_COURSE_STATUS_STUDENT_STARTED = 1;
export const USER_COURSE_STATUS_STUDENT_FINISHED = 2;

export const QUIZ_STATUS_FAILED = 1;
export const QUIZ_STATUS_PASSED = 2;

export const USER_TOPIC_STATUS_STARTED = 1;
export const USER_TOPIC_STATUS_FINISHED = 2;

export const USER_LESSON_STATUS_STARTED = 1;
export const USER_LESSON_STATUS_FINISHED = 2;

export const USER_ROLE_ADMIN = 1;
export const USER_ROLE_MANAGER = 2;
export const USER_ROLE_TEACHER = 3;
export const USER_ROLE_STUDENT = 4;

export const COOKIE_TYPE_ADMIN = 'admin';

export const API_PORT = '2052';

export const PATH_TO_DEFAULT_AVATARS = './static/images/Profile_';

export const NOTIFIABLE_TYPE_LESSON = 'lesson';
export const NOTIFIABLE_TYPE_COURSE = 'course';

export const MILLISECOND_IN_MINUTE = 60000;
export const USER_TOPIC_INTERVAL_MINUTE = 1;

export const SUCCESS_IFRAME_LOAD = 1;
export const REDIRECT_IFRAME = 2;
export const CHECK_LESSON_PASSWORD = 3;
export const INCORRECT_LESSON_PASSWORD = 4;
export const LESSON_DATA = 5;

export const SET_TIMEOUT = 2000;



// WEBPACK FOOTER //
// ./src/utils/constants.js